export function indexConditions(conditionalVariantValues) {
	const index = {};
	conditionalVariantValues.forEach((ccv) => {

		const conditionStrings = [...ccv.conditions]
			.map( (condition) => condition.featureId + '.' + condition.valueId);

		// WORKAROUND: Remove 'RETURN_' from id
		const id = ccv.id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');

		const key = ccv.type + '.' + id + '.' + ccv.side;
		const item = {
			conditions: conditionStrings,
			value: ccv.value
		};

		if (key in index) {
			// existing condition
			index[key].push(item);
		} else {
			// new condition
			index[key] = [item];
		}

	});
	return index;
}
